import React, { createContext } from "react";
import { Action, State } from "./type";

const initialState: State = {
  theme: "light",
  userInfo: null,
  isLogin: null,
  locale: "en",
  localeLink: "",
  hideSignUpAndLogIn: false,
  isDemoTrading: false,
  baseUrl: "",
  showTheme: false,
  changeTheme: undefined,
  position: "sticky",
  drawerOpen: false,
  isSticky: false,
  themeLock: false,
  hideAllMenus: false,
  country: ""
};

const StoreContext = createContext<{
  state: State;
  dispatch: React.Dispatch<Action>;
}>({
  state: initialState,
  dispatch: () => null
});

export { initialState, StoreContext };
